import { memo, useCallback, useMemo, useState, useEffect } from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { COLOR, FONT, THEME } from '../../constants/styles';

const CALENDAR_ICON = require('../../../resources/nav/icon-calendar.png');
// const MESSAGES_ICON = require('../../../resources/nav/icon-messages.png');
const HOME_ICON = require('../../../resources/nav/icon-home.png');

import { HOME_TAB, CALENDAR_TAB } from '../../constants/tabs';

import { MainNavItem } from './sidebar_nav_item';

export default memo(function SideNav(props) {
  const dispatch = useDispatch();

  const openScreen = useCallback(
    (screenConfig) => {
      const { screen, passProps } = screenConfig;
      props.openScreen?.(screenConfig);
    },
    [props.openScreen]
  );

  const navItems = useMemo(() => {
    const items = [
      {
        label: 'Home',
        icon: HOME_ICON,
        screenConfig: { screen: 'Home', nativeTab: HOME_TAB },
        selected: props.currentTab === 'Home',
      },
      {
        label: 'Calendar',
        icon: CALENDAR_ICON,
        screenConfig: { screen: 'Calendar', nativeTab: CALENDAR_TAB },
        selected: props.currentTab === 'Calendar',
      },
      // {
      //   label: 'Messages',
      //   icon: MESSAGES_ICON,
      //   screenConfig: { screen: 'Messages', nativeTab: MESSAGING_TAB },
      //   selected: props.currentTab === 'Messages',
      // },
    ];
    return items;
  }, [props.currentTab]);

  return (
    <>
      <View style={styles.mainNav}>
        {navItems.map((item) => (
          <MainNavItem key={item.label} {...item} onPress={openScreen} />
        ))}
      </View>
    </>
  );
});

const styles = StyleSheet.create({
  mainNav: {
    backgroundColor: COLOR.labelText,
  },
});
